// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.administration-container {
  width: 81.7%;
  height: 90vh;
  margin-left: 19%;
}
@media (max-width: 1024px) {
  .administration-container {
    margin-left: 31%;
  }
}
.administration-container .administration-inner-container {
  align-items: center;
  width: 60%;
}
@media (max-width: 1024px) {
  .administration-container .administration-inner-container {
    width: 63%;
  }
}
.administration-container .image-inner-container {
  justify-content: flex-end;
  width: 44%;
  height: 81.7vh;
  position: fixed;
  right: 0px;
}
@media (max-width: 1024px) {
  .administration-container .image-inner-container {
    width: 50%;
    height: 90.7vh;
  }
}

.image-opacity {
  opacity: 0.1;
}`, "",{"version":3,"sources":["webpack://./src/components/Administration/style.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AACF;AACE;EALF;IAMI,gBAAA;EAEF;AACF;AAAE;EACE,mBAAA;EACA,UAAA;AAEJ;AAAI;EAJF;IAKI,UAAA;EAGJ;AACF;AAAE;EACE,yBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;AAEJ;AAAI;EAPF;IAQI,UAAA;IACA,cAAA;EAGJ;AACF;;AACA;EACE,YAAA;AAEF","sourcesContent":[".administration-container {\r\n  width: 81.7%;\r\n  height: 90vh;\r\n  margin-left: 19%;\r\n\r\n  @media (max-width: 1024px) {\r\n    margin-left: 31%;\r\n  }\r\n\r\n  .administration-inner-container {\r\n    align-items: center;\r\n    width: 60%;\r\n\r\n    @media (max-width: 1024px) {\r\n      width: 63%;\r\n    }\r\n  }\r\n\r\n  .image-inner-container {\r\n    justify-content: flex-end;\r\n    width: 44%;\r\n    height: 81.7vh;\r\n    position: fixed;\r\n    right: 0px;\r\n\r\n    @media (max-width: 1024px) {\r\n      width: 50%;\r\n      height: 90.7vh;\r\n    }\r\n  }\r\n}\r\n\r\n.image-opacity {\r\n  opacity: 0.1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
